import {formatLeavingGroup} from 'molbio/adcs/linker-payload-connection/AdcLinkerPayloadLeavingGroupSerialization';

export function invalidLinkerPayloadLeavingGroupError(leavingGroup: number): string {
  return `${formatLeavingGroup(leavingGroup)} is not a leaving group of the linker-payload.`;
}
